import React, { useState,Component } from 'react';
import axios from 'axios';
import { setUserSession } from '../utils/Common';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import {Footer} from 'react-materialize';
import DataService from "../services/data.service";
import Message from '../component/Message';
import Loading from '../component/loading';
import { withRouter } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'
import moment from 'moment'


class Success_paid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationId:"",
      amount:"",
      transactionDate:""
    }
   
   
  }
  componentDidMount() 
  {
    debugger
  if(this.props.location.data!=undefined &&this.props.location.data!=undefined)
  {
    let nextProps=this.props.location.data;
    var amount = parseFloat(nextProps.amount.total);
    var tax = parseFloat(nextProps.amount.tax);
    var total = (tax + amount).toFixed(2);
    var date = new Date(nextProps.transactionDate).toISOString();

    var orderdate=moment(date).format("MM-DD-YYYY");

    this.setState ({
    
      confirmationId:nextProps.confirmationId,
      amount:total,
      transactionDate:orderdate,
    })
  }
  else
  {
    window.location.href = '/'
  }

  }

    render() {
        return (

        <div id="popup1" class="overlay_cus_suceess">
        <div class="summary_popup_loading ">
           
            {/* <a class="close hand" onClick={props.handle_message}>&times;</a> */}
            <div class="row">
            <div class="col-md-12 col-12 thank_info_title">
                <h3 class="">Payment Summary</h3>
            </div>
            <div class="col-md-12 col-12 thank_info">
               Thank you! We have received your payment.
            </div>
            
            </div>
            <div class="back_summary">
          
            <div class="row mt-5 p-3">
               <div class="col-md-6 col-6 text-left futura">
                 Confirmation #:
                  
              </div>
              <div class="col-md-6 col-6 text-left product_info_title">
                    {this.state.confirmationId}
              </div>
            </div>
            <div class="row p-3" >
               <div class="col-md-6 col-6 text-left">
               <label class="text-left futura"> Payment Date:</label>
                  
              </div>
              <div class="col-md-6 col-6 text-left product_info_title">
                  {this.state.transactionDate}
              </div>
            </div>
            <div class="row p-3">
               <div class="col-md-6 col-6 text-left">
               <label class="text-left futura"> Payment Total:</label>
                   
              </div>
              <div class="col-md-6 col-6 text-left product_info_title">
                    ${this.state.amount}
              </div>
            </div>
            </div>
           
        </div>
        </div>
          );
    }
  
}
export default withRouter(Success_paid);
